var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 9,
    fill: "#0A66C2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9379 25.6004V12.6455H6.65044V25.6004H10.9379ZM8.79531 10.8774C10.29 10.8774 11.2209 9.88237 11.2209 8.63889C11.1933 7.36767 10.29 6.40039 8.82407 6.40039C7.35696 6.40039 6.39844 7.36767 6.39844 8.63889C6.39844 9.88237 7.32819 10.8774 8.76769 10.8774H8.79531ZM13.3106 25.6004H17.598V18.366C17.598 17.9789 17.6256 17.5917 17.7396 17.3155C18.0491 16.5412 18.7545 15.7404 19.9397 15.7404C21.4908 15.7404 22.111 16.9284 22.111 18.6699V25.5992H26.3984V18.1719C26.3984 14.193 24.2835 12.3416 21.4632 12.3416C19.1503 12.3416 18.1354 13.6394 17.5704 14.5235H17.5992V12.6455H13.3106C13.367 13.8613 13.3106 25.6004 13.3106 25.6004Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLink);
export default __webpack_public_path__ + "static/media/linkedin-link.c9c86f520df36c57800765600c6afe5c.svg";
export { ForwardRef as ReactComponent };